module.exports = __webpack_public_path__ + "assets/media/lunch.485f370c.mp3";